import { generateClient } from 'aws-amplify/api';
import PropTypes from 'prop-types';
import { createDJTUnitDriver } from '../../../graphql/custom_mutations';

const client = generateClient();

export const addDJTUnitDriver = async (props) => {
  if (props) {
    try {
      console.log('addDJTUnitDriver props: ', props);

      const response = await client.graphql({
        query: createDJTUnitDriver,
        variables: { input: props },
      });

      console.log('addDJTUnitDriver response: ', response);
      const results = response.data.createSpkDJTDriverTbl.id;
      return results;
    } catch (err) {
      return 'error addDJTUnitDriver: ' + err;
    }
  } else {
    return null;
  }
};

addDJTUnitDriver.propTypes = {
  props: PropTypes.object.isRequired,
};
